import { AfterViewInit, Component, OnInit } from '@angular/core';
import { MatDialog, MatDialogRef } from '@angular/material/dialog';
import { Router } from '@angular/router';
import { IClientResponse } from 'src/app/library/interfaces/client/client-response';

@Component({
    selector: 'app-new-case-dialog',
    templateUrl: './new-case-dialog.component.html',
    styleUrls: ['./new-case-dialog.component.scss']
})
export class NewCaseDialogComponent implements OnInit, AfterViewInit {
    constructor(
        public dialogRef: MatDialogRef<NewCaseDialogComponent>,
        private router: Router,
        public dialog: MatDialog
    ) {}

    ngOnInit() {}

    ngAfterViewInit() {}

    public getSelectedClient(event: IClientResponse) {
        if (event) {
            this.router.navigateByUrl(
                `/app/cases/case/overview/${event.policy.policyId}/${event.clientId}`
            );
            this.dialogRef.close();
        }
    }
}
